import { axios, Response } from '../index'

const deletePersonaFolder = (folderId: string): Response<null> => {
  return axios.delete(`/v1/folders/${folderId}`)
}

export default deletePersonaFolder
